"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgFlagOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25.72 3.34A22.86 22.86 0 0120 4a9 9 0 01-3.92-1A9.64 9.64 0 0012 2a10.39 10.39 0 00-5.57 1.47l-.43.3V30h2V17.88a9.28 9.28 0 014-.88 7.75 7.75 0 013.29.86A11.08 11.08 0 0020 19a17.77 17.77 0 006.38-1.06l.62-.25V3zM25 16.28a17.58 17.58 0 01-5 .7 9 9 0 01-3.92-1A9.64 9.64 0 0012 15a11.38 11.38 0 00-4 .71V4.88A9.13 9.13 0 0112 4a7.75 7.75 0 013.29.86A11.08 11.08 0 0020 6a28.11 28.11 0 005-.43z" })));
}
exports.default = SvgFlagOutline;
//# sourceMappingURL=FlagOutline.js.map